
    // IMPORTS
    import { defineComponent } from 'vue'
    import { useSessionStore } from '@/store/session';

    export default defineComponent({
        name: 'LogoffPage',

        setup() {
            const sessionStore = useSessionStore()
            sessionStore.logOff()
        }
    });
